import { getCssVariable } from '@fourthwall/components';
import React from 'react';
import tinycolor from 'tinycolor2';
import { getEmojiIcon } from '../../../../utils';
import { FormFields } from '../../hooks/useBadgeForm/types';
import { ColorInput } from '../ColorInput';
import { EmojiInput } from '../EmojiInput';
import { MainInputsLayout } from '../MainInputsLayout/MainInputsLayout';
export const MainInputs = ({ form }) => {
    const colorOnBackground = getCssVariable('--color-on-background');
    return (React.createElement(MainInputsLayout, null,
        React.createElement(EmojiInput, { emoji: getEmojiIcon(form.values.emoji), onChange: (emoji) => {
                if (emoji.type === 'ImageResource') {
                    form.setFieldValue(FormFields.emoji, {
                        type: 'ImageResource',
                        url: emoji.url,
                        imageResourceId: emoji.imageResourceId,
                    });
                }
                else {
                    form.setFieldValue(FormFields.emoji, {
                        type: 'Emoji',
                        emojiIcon: emoji.emojiIcon,
                    });
                }
            } }),
        React.createElement(ColorInput, { label: "Border", color: form.values.borderColor, defaultColor: tinycolor(colorOnBackground).setAlpha(0.3).toRgbString(), onChange: (color) => form.setFieldValue(FormFields.borderColor, color) }),
        React.createElement(ColorInput, { label: "Background", color: form.values.backgroundColor, defaultColor: tinycolor(colorOnBackground).setAlpha(0.1).toRgbString(), onChange: (color) => form.setFieldValue(FormFields.backgroundColor, color) }),
        React.createElement(ColorInput, { label: "Text", color: form.values.textColor, defaultColor: colorOnBackground, onChange: (color) => form.setFieldValue(FormFields.textColor, color) })));
};
